var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dynamic-content-wrapper"},[(_vm.uiFlags.isFetching)?_c('div',{staticClass:"loader"},[_c('spinner')],1):(_vm.content)?_c('div',{staticClass:"column content-box changelog-wrapper overflow-auto",domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._t("fallback")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }